import React from 'react';
import { Card } from '../../../../components/ui/Card';
import { Input } from '../../../../components/ui/Input';
import { Button } from '../../../../components/ui/Button/Button';
import { Plus, Mail, Clock } from 'lucide-react';

interface CampaignSequenceProps {
  data: any;
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
}

export const CampaignSequence: React.FC<CampaignSequenceProps> = ({ data, onChange, errors }) => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100 mb-2">
          Campaign Sequence
        </h2>
        <p className="text-neutral-600 dark:text-neutral-400">
          Set up your outreach sequence and timing
        </p>
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-4">
          Email Sequence
        </h3>
        <div className="space-y-6">
          {/* Step 1 */}
          <div className="border border-neutral-200 dark:border-neutral-700 rounded-lg p-4">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white text-sm font-medium">
                  1
                </div>
                <div>
                  <h4 className="font-medium text-neutral-900 dark:text-neutral-100">Initial Email</h4>
                  <p className="text-sm text-neutral-600 dark:text-neutral-400">First contact</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-neutral-400" />
                <span className="text-sm text-neutral-600 dark:text-neutral-400">Email</span>
              </div>
            </div>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
                  Subject Line
                </label>
                <Input placeholder="Enter subject line..." />
              </div>
              <div>
                <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
                  Wait Time
                </label>
                <div className="flex items-center space-x-2">
                  <Input type="number" placeholder="3" className="w-20" />
                  <span className="text-sm text-neutral-600 dark:text-neutral-400">days after enrollment</span>
                </div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="border border-neutral-200 dark:border-neutral-700 rounded-lg p-4">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center text-white text-sm font-medium">
                  2
                </div>
                <div>
                  <h4 className="font-medium text-neutral-900 dark:text-neutral-100">Follow-up Email</h4>
                  <p className="text-sm text-neutral-600 dark:text-neutral-400">First follow-up</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-neutral-400" />
                <span className="text-sm text-neutral-600 dark:text-neutral-400">Email</span>
              </div>
            </div>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
                  Subject Line
                </label>
                <Input placeholder="Enter subject line..." />
              </div>
              <div>
                <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-1">
                  Wait Time
                </label>
                <div className="flex items-center space-x-2">
                  <Input type="number" placeholder="5" className="w-20" />
                  <span className="text-sm text-neutral-600 dark:text-neutral-400">days after previous step</span>
                </div>
              </div>
            </div>
          </div>

          <Button variant="outline" className="w-full">
            <Plus className="w-4 h-4 mr-2" />
            Add Step
          </Button>
        </div>
      </Card>
    </div>
  );
}; 